import { BASE_URL } from './config';

export const uploadDocument = async (file, token) => {
  try {
    const formData = new FormData();
    formData.append('title', file.name);
    formData.append('file', file);

    const res = await fetch(`${BASE_URL}documents`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await res.json();
    if (res.ok) {
      return { success: true, httpStatus: res.status, ...data };
    }
    return {
      success: false,
      httpStatus: res.status,
      error: data.message || data.error || `HTTP error! status: ${res.status}`,
      ...data,
    };
  } catch (error) {
    console.error('Upload document API Error:', error);
    return {
      success: false,
      error: error.message || 'Network error',
    };
  }
};

export const convertDocxToPdf = async (file, token) => {
  try {
    const formData = new FormData();
    formData.append('title', file.name);
    formData.append('file', file);

    const res = await fetch(`${BASE_URL}documents/convert`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (res.ok) {
      const pdfBlob = await res.blob();
      const pdfFile = new File(
        [pdfBlob],
        file.name.replace(/\.docx$/, '.pdf'),
        {
          type: 'application/pdf',
        }
      );
      return { success: true, httpStatus: res.status, pdfFile };
    }
    const errorText = await res.text();
    return {
      success: false,
      httpStatus: res.status,
      error: errorText || `HTTP error! status: ${res.status}`,
    };
  } catch (error) {
    console.error('Convert DOCX to PDF API Error:', error);
    return {
      success: false,
      error: error.message || 'Network error',
    };
  }
};

export const uploadFeedbackDocument = async (feedbackData, token) => {
  try {
    const res = await fetch(`${BASE_URL}laporan/laporan`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: feedbackData,
    });

    const data = await res.json();

    if (res.ok) {
      return { success: true, httpStatus: res.status, ...data };
    }

    return {
      success: false,
      httpStatus: res.status,
      error: data.message || data.error || `HTTP error! status: ${res.status}`,
      ...data,
    };
  } catch (error) {
    console.error('Upload feedback document API Error:', error);
    return {
      success: false,
      error: error.message || 'Network error',
    };
  }
};

export const createDraft = async (docId, token) => {
  try {
    const res = await fetch(`${BASE_URL}documents/duplicate/${docId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Create Draft API Error:', error);
    return { success: false, error: error.message };
  }
};

export const uploadPhoto = async (file, token) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const res = await fetch(`${BASE_URL}profile/profile-picture`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await res.json();
    if (res.ok) {
      return { success: true, httpStatus: res.status, ...data };
    }
    return {
      success: false,
      httpStatus: res.status,
      error: data.message || data.error || `HTTP error! status: ${res.status}`,
      ...data,
    };
  } catch (error) {
    console.error('Upload photo API Error:', error);
    return {
      success: false,
      error: error.message || 'Network error',
    };
  }
};
